import { alpha } from "@mui/material"
import { useContextState } from "../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()

  return {
    daysOfWeek: (flag:boolean,startDay:boolean) => ({
        width: 50,
        height: 50,
        borderRadius: '0px',
        backgroundColor: flag ? colors.secondaryEndpoint : 'white' /* :  */,
        border: startDay ? ` 3px solid ${colors.contrastEndpoint}` : flag ? '' : `2px solid ${colors.color13}` /* : flag ? ` 3px solid ${colors.contrastEndpoint}`:'' */,
        color: flag ? 'white' : colors.color13 /* :  */ ,
        transition: 'background-color 0.3s',
        '&:hover': {
            backgroundColor: /* flag ? */ alpha(colors.secondaryEndpoint, 0.5) /* : colors.color16 */,
            color:'white',
            //border: flag ? ` 3px solid ${colors.primaryEndpoint}`:''
        },
    })
  }
}

export { useStyles }